import React, { useState, useCallback } from 'react';
import FinancialProductRulesEditContainer from './FinancialProductRulesEditContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_FINANCIAL_PRODUCT_WRITE, ADMIN_FINANCIAL_PRODUCT_READ } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const productId = match.params.id && getInt(match.params.id);
  const ruleId = match.params.ruleId && getInt(match.params.ruleId);
  const [title, setTitle] = useState('');

  const permissionRead = usePermission(ADMIN_FINANCIAL_PRODUCT_READ);
  const permissionWrite = usePermission(ADMIN_FINANCIAL_PRODUCT_WRITE);

  const productName = (historyContext?.location?.state?.productName ?? "");

  const onClickClose = useCallback(() => {
    historyContext.push(`/financialProducts/${productId}`, { from: 'Rules' });
  }, [historyContext, productId]);

  const onChangeTitle = useCallback(title => {
    setTitle(title);
  }, []);

  const onRedirect = useCallback(ruleId => {
    const rules = historyContext?.location?.state?.financialProductRules;
    historyContext.push(`/financialProducts/${productId}/rules/${ruleId}`, {financialProductRules: rules || []});
  }, [historyContext, productId]);

  return permissionRead || permissionWrite ? (
    <>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header productName={productName} title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <FinancialProductRulesEditContainer
        canWrite={permissionWrite}
        productId={productId}
        ruleId={ruleId}
        onRedirect={onRedirect}
        onChangeTitle={onChangeTitle}
      />
    </>
  ) : (
    <></>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
